"use strict";

module.exports.STATUS_MAPPING = {
  mapped: 1,
  valid: 2,
  disallowed: 3,
  deviation: 6,
  ignored: 7
};
